module.exports = __webpack_public_path__ + "img/welcomes-preview-no-vip.a1801167.png";